import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppStorageEnum } from 'src/app/models/storage.enum';
import { LANG_SET } from 'src/app/helpers';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {
  public activeLanguage: Language;

  constructor(
    private translate: TranslateService,
    @Inject(LANG_SET) private languages: Language[],
  ) {
    this.translate.setDefaultLang(this.engLang.lang);
    const lang = localStorage.getItem(AppStorageEnum.storeLanguage) ? localStorage.getItem(AppStorageEnum.storeLanguage) : this.translate.getBrowserLang();
    this.setCurrentLang(lang);
  }

  private get engLang(): Language {
    return this.languages.find(el => el.id === 'en');
  }

  public setCurrentLang(lang: string) {
    this.activeLanguage = this.languages.find(el => lang === el.lang || lang === el.id) || this.engLang;
    this.translate.use(this.activeLanguage.lang);
    localStorage.setItem(AppStorageEnum.storeLanguage, this.activeLanguage.lang);
  }

  public getCurrentLang(): string {
    return this.activeLanguage.lang;
  }

}

export interface Language {
  id: string;
  name: string;
  lang: string;
  code: string;
}
